import React from "react";
import { Link } from "react-router-dom";
import "../css/AboutUs.css";
import CONTACT from "../config/contact";

// About Mithralaya — written for Mithralaya (the old page told Bullrise's
// story). ⚠️ Owner: add your own founding story in "Our story" if you like.
const AboutUs = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <span className="about-tag">Women's &amp; Kids Wear · Chennai</span>
          <h1>About Mithralaya</h1>
          <p>
            Sarees, kurtis and churidar sets for women, and comfortable everyday
            wear for children — chosen with care in Chennai and delivered across India.
          </p>
        </div>
      </section>

      <section className="about-content container">
        <div className="about-card">
          <h2>Our story</h2>
          <p>
            Mithralaya is a Chennai store for the whole family's wardrobe. We bring
            together traditional weaves — Kanjivaram, Arani, Banarasi, Chettinad and
            other sarees — with easy kurtis, churidar sets, tops, nightwear and kidswear
            for every day.
          </p>
          <p>
            Every piece is checked in our store before it is packed, and each listing
            shows the real fabric, colour and size so you know what you are getting.
          </p>
        </div>

        <h2 className="section-title">What we promise</h2>

        <div className="values-grid">
          <div className="value-card">
            <h3>Honest products</h3>
            <p>Clear photos, the actual fabric and colour, and a size chart for every category.</p>
          </div>
          <div className="value-card">
            <h3>Easy buying</h3>
            <p>Pay online or with cash on delivery, and track every order from your account.</p>
          </div>
          <div className="value-card">
            <h3>Simple returns</h3>
            <p>
              Changed your mind? Return unused items within 7 days of delivery —{" "}
              <Link to="/return-refunds">see how returns work</Link>.
            </p>
          </div>
        </div>

        <div className="mission-card">
          <h2>Visit or call us</h2>
          <p>
            {CONTACT.addressLines.join(", ")}
            <br />
            <a href={CONTACT.phoneHref}>{CONTACT.phone}</a> ·{" "}
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            <br />
            {CONTACT.hours}
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
